var mcb = mcb || {};

mcb.accordion = mcb.accordion || new function () {

    this.init = function () {

        const accordions = document.querySelectorAll('.accordion');

        accordions.forEach(accordion => {

            let isOpen = false;
            let expandButton = accordion.querySelector('.expand-accordion');

            if (!expandButton)
                return;

            const textExpandAll = expandButton.getAttribute("data-expand-all");
            const textCollapseAll = expandButton.getAttribute("data-collapse-all");

            const collapseElementList = accordion.querySelectorAll('.accordion-collapse');
            const collapsedElements = [...collapseElementList].filter(element => element.classList.contains('show'));
            let openCount = collapsedElements.length;

            collapseElementList.forEach(el => {
                el.addEventListener('hide.bs.collapse', () => {
                    openCount--;

                    if (openCount < collapseElementList.length) {
                        expandButton.classList.remove("open");
                        expandButton.innerHTML = textExpandAll;
                    }
                });

                el.addEventListener('show.bs.collapse', () => {
                    openCount++;

                    if (openCount === collapseElementList.length) {
                        expandButton.classList.add("open");
                        expandButton.innerHTML = textCollapseAll;
                    }
                });
            });

            expandButton.addEventListener('click', e => {
                expandButton.classList.toggle("open");

                isOpen = openCount === collapseElementList.length;

                const collapseList = [...collapseElementList].map(collapseEl => bootstrap.Collapse.getOrCreateInstance(collapseEl));

                collapseList.forEach(el => {
                    if (isOpen) {
                        el.hide();
                    }
                    else {
                        el.show();
                    }
                });

                isOpen = !isOpen;
                
                if (isOpen) {
                    openCount = collapseElementList.length;
                    expandButton.innerHTML = textCollapseAll;
                }
                else {
                    openCount = 0;
                    expandButton.innerHTML = textExpandAll;
                }
            });
        });
    };

}();